import gql from 'graphql-tag';
import { FontFragments } from '../fonts/font.fragment';

export const entity = gql`
  query entity {
    entity {
      id
      name
      companyName
      registeredNumber
      logoUrl
      securityPassword
      securitySms
      isSmsSending
      countryCode
      currency
      timezone
      theme {
        id
        name
        backgroundColor
        backgroundImage
        backgroundType
        accentColor
        signButtonText
        fontSettings {
          defaultFont {
            ...fontFragment
          }
          headingsFont {
            ...fontFragment
          }
        }
      }
      address
      zip
      state
      city
      country
      website
      email
      isSmsReminder
      isReminderSending
      reminderOpened
      reminderSigned
      reminderExpiration
      billingEmail
      billingVat
      billingNote
      billingMethod
      billingCompany
      billingAddress
      billingZip
      billingState
      billingCity
      billingCountry
      billingReference
      billingCurrency
      autoCommentText
      autoCommentEmail
      smsReminderText
      isAutoComment
      isAutoCommentEmail
      reminderSignedDays
      reminderRepeat
      reminderRepeatDays
      reminderExpirationDays
      reminderOpenedDays
      reminderWeekend
      notificationEmail
      notificationOpened
      notificationViewed
      notificationReviewed
      notificationCommented
      notificationSigned
      notificationRejected
      notificationBounced
      notificationDownloaded
      notificationPrinted
      notificationForwarded
      notificationExpired
      notificationAttachment
      documentDownload
      isSigningForward
      isSelfsign
      verifySmsSign
      verifySmsOpen
      isSigningBiometric
      isSigningInitials
      isSigningEid
      isSigningWrite
      isDisableComment
      isIdentifyRecipient
      isEsignConsent
      documentUniqueId
      signCopyEmail
      customFingerprint
      smsSender
      emailSenderName
      emailSenderAddress
      defaultExpirationDays
      language
      appMode
      domainName
      signRedirect
      subDomain
      emailNotificationTemplateId
      emailSendTemplateId
      modules {
        id
        name
        status
      }
      datacenter {
        name
      }
      parentEntityId
      settings {
        organizationWideSaml
        blockQualifiedElectronicSignature
        contextualCommenting
        immutableSettings {
          verifySmsOpen
        }
      }
    }
  }
  ${FontFragments.fontFragment}
`;

export const securitySettings = gql`
  query securitySettings {
    entity {
      securityPassword
      securityRestrict
      securitySocial
      securitySms
      securityAttachment
      securityTwofactor
      securityCertificate
      securitySms
      securityShare
    }
  }
`;

export const addons = gql`
  query Addons {
    addons {
      addon
      limit
    }
  }
`;

export const teams = gql`
  query entityTeams {
    entity {
      id
      teams {
        id
        name
        status
      }
    }
  }
`;

export const dataRemovalSettings = gql`
  query dataRemovalSettings {
    entity {
      removeInactive
      removeInactiveMonths
      removeSigned
      removeSignedMonths
      removeNotificationEmail
    }
  }
`;

export const dataProtectionSettings = gql`
  query dataProtectionSettings {
    entity {
      removeConsent
      removeConsentText
      trackingConsent
      trackingConsentText
      securityObfuscate
      securitySignedAttachment
    }
  }
`;
